var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGlobalEdit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "vuesax/linear/global-edit"
  }, /*#__PURE__*/React.createElement("g", {
    id: "global-edit"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M14.6668 7.99967C14.6668 4.31967 11.6802 1.33301 8.00016 1.33301C4.32016 1.33301 1.3335 4.31967 1.3335 7.99967C1.3335 11.6797 4.32016 14.6663 8.00016 14.6663",
    stroke: "#173D33",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M5.33372 2H6.00039C4.70039 5.89333 4.70039 10.1067 6.00039 14H5.33372",
    stroke: "#173D33",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M10 2C10.6467 3.94667 10.9733 5.97333 10.9733 8",
    stroke: "#173D33",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M2 10.6667V10C3.94667 10.6467 5.97333 10.9733 8 10.9733",
    stroke: "#173D33",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M2 5.99941C5.89333 4.69941 10.1067 4.69941 14 5.99941",
    stroke: "#173D33",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M12.8065 10.4933L10.4465 12.8534C10.3532 12.9467 10.2665 13.12 10.2465 13.2467L10.1199 14.1467C10.0732 14.4733 10.2999 14.7 10.6265 14.6533L11.5265 14.5267C11.6532 14.5067 11.8332 14.42 11.9199 14.3267L14.2799 11.9667C14.6865 11.56 14.8799 11.0867 14.2799 10.4867C13.6865 9.89334 13.2132 10.0867 12.8065 10.4933Z",
    stroke: "#173D33",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    d: "M12.4663 10.833C12.6663 11.553 13.2263 12.113 13.9463 12.313",
    stroke: "#173D33",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGlobalEdit);
export default __webpack_public_path__ + "static/media/global-edit.5231ac975d65fc6ac8ff5d7029bae85e.svg";
export { ForwardRef as ReactComponent };